import AdditionalFeeManagementDeleteModal from './AdditionalFeeManagementDeleteModal.vue';

export default AdditionalFeeManagementDeleteModal;
